import React from 'react';
import { Box, TextField, MenuItem } from '@mui/material';
import { numberOfDays, fillRange, incrementList, getMonthString } from '../logic';
import makeStyles from './styles';

type dateSelector = {
  date: Date;
  selected?: number;
  setSelected: Function;
  time?: { hours?: number; minutes?: number };
  setTime: Function;
};
const DateSelector = ({ date, selected, setSelected, time, setTime }: dateSelector) => {
  const startingDate = selected ? new Date(selected) : new Date(date);
  const classes = makeStyles();

  return (
    <Box display="flex">
      <TextField
        variant="standard"
        id="set-month"
        InputProps={{ classes: { input: classes.input } }}
        select
        value={selected ? startingDate.getMonth() : 'Month'}
        onChange={(event: any) => setSelected(startingDate.setMonth(event.target.value))}
      >
        <MenuItem selected disabled value="Month">
          <em>Month</em>
        </MenuItem>
        {fillRange(0, 11).map((option: number) => (
          <MenuItem key={option} value={option}>
            {getMonthString(option)}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        variant="standard"
        id="set-day"
        InputProps={{ classes: { input: classes.input } }}
        select
        value={selected ? startingDate.getDate() : 'Day'}
        onChange={(event: any) => setSelected(startingDate.setDate(event.target.value))}
      >
        <MenuItem selected disabled value="Day">
          <em>Day</em>
        </MenuItem>
        {numberOfDays(startingDate).map((option: number) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        variant="standard"
        id="set-year"
        InputProps={{ classes: { input: classes.input } }}
        select
        value={selected ? startingDate.getFullYear() : 'Year'}
        onChange={(event: any) => setSelected(startingDate.setFullYear(event.target.value))}
      >
        <MenuItem selected disabled value="Year">
          <em>Year</em>
        </MenuItem>
        {incrementList(startingDate.getFullYear()).map((option: number) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        variant="standard"
        id="set-hour"
        InputProps={{ classes: { input: classes.input } }}
        select
        value={time && (!!time.hours || time.hours === 0) ? time.hours : 'Hour'}
        onChange={(event: any) => setTime({ ...time, hours: event.target.value })}
      >
        <MenuItem selected disabled value="Hour">
          <em>Hour</em>
        </MenuItem>
        {fillRange(0, 23).map((option: number) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        variant="standard"
        id="set-minutes"
        InputProps={{ classes: { input: classes.input } }}
        select
        value={time && (!!time.minutes || time.minutes === 0) ? time.minutes : 'Minute'}
        onChange={(event: any) => setTime({ ...time, minutes: event.target.value })}
      >
        <MenuItem selected disabled value="Minute">
          <em>Minute</em>
        </MenuItem>
        {fillRange(0, 59).map((option: number) => (
          <MenuItem key={option} value={option}>
            {option < 10 ? `0${option}` : option}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
};
export default DateSelector;
